module.exports = __webpack_public_path__ + "static/media/module1.a262938d.png";